export const agreementsFilterFields = {
  BUYER_REGISTER_CODE: 'buyerRegisterCode',
};

export const FORM_ACCOUNT_GOS_PURCHASING_AGREEMENTS_FILTER =
  'FORM_ACCOUNT_GOS_PURCHASING_AGREEMENTS_FILTER';
